module.exports = __webpack_public_path__ + "img/emoji-confused-80x80.413cd9ec.png";